export default __webpack_public_path__ + "static/media/tree4.e0ffff3f.svg";